import ApiService from "../ApiService";

async function createPatientOnPhoton(userDetail, sexAtBirth) {
  return await ApiService.createPatientOnPhoton({
    patientId: userDetail?.subUUID,
    firstName: userDetail?.givenName,
    lastName: userDetail?.familyName,
    dob: userDetail?.birthDate,
    sex: sexAtBirth,
    phone: userDetail?.phoneNumber,
    email: userDetail?.email,
    gender: userDetail?.gender,
    address: {
      name: {
        first: userDetail?.givenName,
        last: userDetail?.familyName
      },
      street1: userDetail?.address?.street_address,
      street2: userDetail?.address?.street_address2,
      postalCode: userDetail?.address?.postal_code,
      country: "USA",
      state: userDetail?.address?.region,
      city: userDetail?.address?.locality
    }
  });
}

function determineSexAtBirth(genderAtBirth) {
  if (typeof genderAtBirth !== "string") {
    return "UNKNOWN";
  }

  const genderLower = genderAtBirth.trim().toLowerCase();

  if (genderLower.includes("female")) {
    return "FEMALE";
  } else if (genderLower.includes("male")) {
    return "MALE";
  }
  return "UNKNOWN";
}

const ErxService = {
  createPatientOnPhoton,
  determineSexAtBirth
};

export default ErxService;
